<template>
    <div>
        <!-- 送章的表单 -->
        <a-form-item label="刻章头像" :name="['kezhang_attach', 'one_inch_picture']" required>
            <UploadOneInchPicture v-model:value="formState.one_inch_picture" :upload_path="props.upload_path">
            </UploadOneInchPicture>
        </a-form-item>
        <a-form-item :name="['kezhang_attach', 'mailing_type']" label="取章方式" required>
            <a-radio-group v-model:value="formState.mailing_type" button-style="solid" @change="changeMailingType">
                <a-radio-button :value="3">来店取货</a-radio-button>
                <a-radio-button :value="1">快递发货</a-radio-button>
                <!-- <a-radio-button :value="2">跑腿发货</a-radio-button>
                <a-radio-button :value="4">和其他印章一起邮寄</a-radio-button> -->
            </a-radio-group>
        </a-form-item>
        <a-form-item :name="['kezhang_attach', 'mailing_kdgs']" label="快递公司" v-if="formState.mailing_type == 1"
            required>
            <a-radio-group v-model:value="formState.mailing_kdgs" button-style="solid">
                <a-radio-button :value="1"><img :src="formState.mailing_kdgs == 2 ? jdIconBlack : jdIconWhite"
                        style="width: 16px; margin-top: -3px; margin-right: 5px" /> 京东快递
                </a-radio-button>
                <a-radio-button :value="2"><img :src="formState.mailing_kdgs == 1 ? sfIconBlack : sfIconWhite"
                        style="width: 16px; margin-top: -3px; margin-right: 5px" /> 顺丰快递
                </a-radio-button>
            </a-radio-group>
        </a-form-item>
        <a-form-item label="邮寄付款方式" :name="['kezhang_attach', 'mailing_payment']" aria-hidden="true"
            v-if="formState.mailing_type == 1" required>
            <a-radio-group v-model:value="formState.mailing_payment" button-style="solid">
                <a-radio-button :value="1">寄付</a-radio-button>
                <a-radio-button :value="2">到付</a-radio-button>
            </a-radio-group>
        </a-form-item>
        <div v-if="formState.mailing_type == 1">
            <a-form-item @change="
                () => {
                    checkdatastate.recipient_name = formState.recipient_name ? 'success' : 'error';
                }
            " label="收货人姓名" :name="['kezhang_attach', 'recipient_name']" required has-feedback
                :validate-status="checkdatastate.recipient_name">
                <div class="d-flex">
                    <a-input class="mr-1x" placeholder="请输入收货人姓名" v-model:value="formState.recipient_name"></a-input>
                </div>
            </a-form-item>
            <a-form-item label="收货人手机号码" :name="['kezhang_attach', 'recipient_mobile']" has-feedback
                :validate-status="checkdatastate.recipient_mobile" :required="true">
                <div class="d-flex">
                    <a-input class="mr-1x" :value="formState.recipient_mobile" placeholder="请输入收货人手机号码" @change="
                        (v) => {
                            phoneChange(v, 'recipient_mobile');
                        }
                    ">
                    </a-input>
                    <a-button :loading="state.emailLoading" type="primary" @click="emailChange"
                        :icon="h(CloudDownloadOutlined)">自动获取邮寄信息</a-button>
                </div>
            </a-form-item>
            <a-form-item label="收货人省市区" :name="['kezhang_attach', 'recipient_area_ids']" required has-feedback
                :validate-status="checkdatastate.recipient_area_ids">
                <AddressCascader v-model:value="formState.recipient_area_ids" @change="residenceChange">
                </AddressCascader>
            </a-form-item>
            <a-form-item @change="
                () => {
                    checkdatastate.recipient_address = formState.recipient_address ? 'success' : 'error'
                }
            " label="收货人地址" :name="['kezhang_attach', 'recipient_address']" required has-feedback
                :validate-status="checkdatastate.recipient_address">
                <a-textarea placeholder="请输入收货人地址" v-model:value="formState.recipient_address" />
                <a-button type="primary" @click="parseReceiveAddress" :loading="state.parseReceiveAddressLoading"
                    style="margin-top:5px" :icon="h(ScanOutlined)">识别</a-button>
            </a-form-item>
            <a-form-item @change="
                () => {
                    checkdatastate.zipcode = formState.zipcode ? 'success' : 'error'
                }
            " label="邮编" :name="['kezhang_attach', 'zipcode']" required has-feedback
                :validate-status="checkdatastate.zipcode">
                <a-input placeholder="请输入邮编" v-model:value="formState.zipcode"></a-input>
            </a-form-item>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { reactive, ref, onMounted, h, watch } from 'vue'
import { useStore } from 'vuex'
import UploadOneInchPicture from '@/components/basePlus/UploadOneInchPicture.vue'
import AddressCascader from '@/components/base/AddressCascader.vue'
import sfIconBlack from '@/assets/icons/sf-icon-black.png'
import sfIconWhite from '@/assets/icons/sf-icon-white.png'
import jdIconBlack from '@/assets/icons/jd-icon-black.png'
import jdIconWhite from '@/assets/icons/jd-icon-white.png'
import baseService from '@/utils/http/axios'
import { message } from 'ant-design-vue'
import { parseAddress } from '@/utils/util'
import { ScanOutlined, CloudDownloadOutlined } from '@ant-design/icons-vue'
const $store = useStore()
const emit = defineEmits(['update:value', 'change'])
const props = defineProps({
    value: {
        type: Object,
        default: () => { }
    },
    upload_path: {
        type: String,
        default: () => ''
    }
})
interface IState {
    emailLoading: boolean
    parseReceiveAddressLoading: boolean
}
const state = reactive<IState>({
    emailLoading: false,
    parseReceiveAddressLoading: false
})
interface IFormState {
    one_inch_picture: string
    mailing_type: number
    mailing_kdgs: number
    mailing_payment: number
    recipient_name: string
    recipient_mobile: string
    zipcode: string
    recipient_address: string
    recipient_area_ids: string | undefined
}
const formState = reactive<IFormState>({
    one_inch_picture: '',
    mailing_type: 3,
    mailing_kdgs: 1, //默认是京东
    mailing_payment: 2, //默认到付
    recipient_name: '',
    recipient_mobile: '',
    zipcode: '410000',
    recipient_address: '',
    recipient_area_ids: undefined,
})
onMounted(() => {
})
const checkdatastate = reactive<any>({})
//改变值
const changeValue = () => {
    emit('update:value', formState)
    emit('change', formState)
}
watch(
    () => props.value,
    (val) => {
        if (val) {
            formState.one_inch_picture = props.value.one_inch_picture ?? ''
            formState.mailing_type = props.value.mailing_type ?? 3
            formState.mailing_kdgs = props.value.mailing_kdgs ?? 1
            formState.mailing_payment = props.value.mailing_payment ?? 2
            formState.recipient_name = props.value.recipient_name ?? ''
            formState.recipient_mobile = props.value.recipient_mobile ?? ''
            formState.zipcode = props.value.zipcode ?? '410000'
            formState.recipient_address = props.value.recipient_address ?? ''
            formState.recipient_area_ids = props.value.recipient_area_ids ?? undefined
        }
    },
    {
        deep: true,
        immediate: true
    }
)
watch(
    () => formState,
    (val) => {
        if (val) {
            changeValue()
        }
    },
    {
        deep: true,
        immediate: true
    }
)
const phoneChange = (v, type) => {
    let str = v.target.value.replaceAll(/\D/g, '')
    formState[type] = str
    //判断str是不是手机号码
    if (!/^1[23456789]\d{9}$/.test(str)) {
        checkdatastate[type] = 'error'
    } else {
        checkdatastate[type] = 'success'
        formState[type] = str
    }
}
// 获取邮寄信息
const emailChange = () => {
    if (!formState.recipient_mobile) {
        message.warn('请填写收货人手机号码再获取邮寄信息')
        return
    }
    state.emailLoading = true
    let requeryParam = {
        url: '/admin/v1/mailingAddressList',
        method: 'post',
        data: {
            page: 1,
            limit: 'all',
            customer_tel: formState.recipient_mobile
        }
    }
    baseService(requeryParam)
        .then((res: any) => {
            if (res.data.list?.length > 0) {
                formState.recipient_name = res.data.list[0].name
                formState.recipient_mobile = res.data.list[0].tel
                formState.recipient_area_ids = `${res.data.list[0].recipient_province_id},${res.data.list[0].recipient_city_id},${res.data.list[0].recipient_area_id}`
                formState.recipient_address = res.data.list[0].address
                checkdatastate.recipient_name = checkdatastate.recipient_mobile = checkdatastate.recipient_area_ids = checkdatastate.recipient_address = checkdatastate.zipcode = 'success'
            }
            //   message.success(res.msg)
            state.emailLoading = false
        })
        .catch((res) => {
            if (res) {
                state.emailLoading = false
                if (res.msg) {
                    //   message.warning(res.msg)
                    return
                }
            }
        })
}
const changeMailingType = () => {
    if (formState.mailing_type == 1 && !formState.mailing_payment) {
        formState.mailing_payment = 2
    }
}
// 邮寄地址省市区
const residenceChange = (idList, value: any) => {
    let address = ''
    if (value) {
        address = `${value[0].name}${value[1].name}${value[2].name}`
        if (formState.recipient_address == address) {
            checkdatastate.recipient_address = 'error'
        }
    } else {
        checkdatastate.recipient_address = 'error'
    }
    formState.recipient_address = address
    checkdatastate.recipient_area_ids = formState.recipient_area_ids ? 'success' : 'error'
}
//识别收货地址
const parseReceiveAddress = () => {
    state.parseReceiveAddressLoading = true
    parseAddress(formState.recipient_address).then((res: any) => {
        if (res.name) {
            formState.recipient_name = res.name
        }
        if (res.phone) {
            formState.recipient_mobile = res.phone
        }
        if (res.area_ids) {
            formState.recipient_area_ids = res.area_ids
        }
        if (res.address) {
            formState.recipient_address = res.address
        }
    }).catch((res) => {
        message.error(res)
    }).finally(() => {
        state.parseReceiveAddressLoading = false
    })
}
</script>
